// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/InterVariable.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  touch-action: manipulation;
  -webkit-touch-callout: none;
}

html {
  font-size: 16px;
}

html, body {
  width: 100%;
  margin: 0;
  padding: 0;
}

@media screen and (max-width: 1440px) {
  html {
    font-size: 12px;
  }
}
@media screen and (max-width: 1180px) {
  html {
    font-size: 10px;
  }
}
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
/* Scrollbar container */
::-webkit-scrollbar {
  width: 8px; /* Set the width of the scrollbar */
  height: 8px;
}

/* Scrollbar track */
::-webkit-scrollbar-track {
  background: #f0f0f0; /* Track color */
  border-radius: 4px; /* Rounded corners for the track */
}

/* Scrollbar thumb */
::-webkit-scrollbar-thumb {
  background-color: #888; /* Scrollbar thumb color */
  border-radius: 4px; /* Rounded corners for the thumb */
  border: 2px solid #f0f0f0; /* Padding around the thumb */
}

/* Scrollbar thumb hover */
::-webkit-scrollbar-thumb:hover {
  background-color: #555; /* Color on hover */
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,2BAAA;AACF;;AAEA;EACE,eAAA;AACF;;AACA;EACE,WAAA;EACA,SAAA;EACA,UAAA;AAEF;;AAAA;EACE;IACE,eAAA;EAGF;AACF;AADA;EACE;IACE,eAAA;EAGF;AACF;AADA;EACE,SAAA;EACA,8JAAA;EAGA,mCAAA;EACA,kCAAA;AACF;;AAEA;EACE,+EAAA;AACF;;AAGA;EACE,oBAAA;EACA,4CAAA;AAAF;AAEA,wBAAA;AACA;EACE,UAAA,EAAA,mCAAA;EACA,WAAA;AAAF;;AAGA,oBAAA;AACA;EACE,mBAAA,EAAA,gBAAA;EACA,kBAAA,EAAA,kCAAA;AAAF;;AAGA,oBAAA;AACA;EACE,sBAAA,EAAA,0BAAA;EACA,kBAAA,EAAA,kCAAA;EACA,yBAAA,EAAA,6BAAA;AAAF;;AAGA,0BAAA;AACA;EACE,sBAAA,EAAA,mBAAA;AAAF","sourcesContent":["* {\n  touch-action: manipulation;\n  -webkit-touch-callout: none;\n}\n\nhtml{\n  font-size: 16px;\n}\nhtml, body {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n}\n@media screen and (max-width: 1440px) {\n  html{\n    font-size: 12px;\n  }\n}\n@media screen and (max-width: 1180px) {\n  html{\n    font-size: 10px;\n  }\n}\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n@font-face{\n  font-family: 'Inter';\n  src: url('../src/fonts/InterVariable.ttf');\n}\n/* Scrollbar container */\n::-webkit-scrollbar {\n  width: 8px; /* Set the width of the scrollbar */\n  height: 8px;\n}\n\n/* Scrollbar track */\n::-webkit-scrollbar-track {\n  background: #f0f0f0; /* Track color */\n  border-radius: 4px; /* Rounded corners for the track */\n}\n\n/* Scrollbar thumb */\n::-webkit-scrollbar-thumb {\n  background-color: #888; /* Scrollbar thumb color */\n  border-radius: 4px; /* Rounded corners for the thumb */\n  border: 2px solid #f0f0f0; /* Padding around the thumb */\n}\n\n/* Scrollbar thumb hover */\n::-webkit-scrollbar-thumb:hover {\n  background-color: #555; /* Color on hover */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
